import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import {ApiService} from "../api/ApiService";
import { DriverProfile } from '../api/model/DriverProfile';
import { UserState, userStore } from '../api/AuthService';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronLeft, ChevronRight, FolderDocIcon, PlateIcon } from '../components/icons';

const Registrations : React.FC = () => {
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(true);

  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));

  const [showModalDoc, setShowModalDoc] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>({});
  const [docs, setDocList] = useState<any>([]);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    ApiService.getRegistrations("registrations", {unitNumber: userInfo.unit})
      .then(it => parseRegistrations(it))
      .finally(() => setLoading(false));
    ApiService.sendEventCommand("Checked Permit", "eventCheck", "User checked the permits page");
  }, []);

  function parseRegistrations(registrationList: any) {
    let tempArray: any[] = []
    registrationList.documents.forEach((element: any) => {
        console.log("temparray", registrationList.documents[registrationList.documents.length - 1]);
        if(element === registrationList.documents[registrationList.documents.length - 1]) {
            tempArray.push(element);
        }
    });
    console.log("registrationList", tempArray);
    setDocList(tempArray)
  }

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Home');
  };

  const metaLine = loading
    ? 'Loading…'
    : `${docs.length} registration${docs.length === 1 ? '' : 's'}`;

  return (
    <IonPage>
      <LoadDetailHeader title="Registrations" onBack={goBack} onSheet={onSheet} />

      <IonContent
        fullscreen
        className="design-a-content design-a-content--light"
        scrollEvents={true}
        onIonScroll={onIonScroll}
      >
        <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
          <div className="home-hero safety-hero">
            <div className="safety-hero__badge" aria-hidden="true">
              <PlateIcon color="#ffffff" size={28} />
            </div>
            <div className="safety-hero__eyebrow">Vehicle documents</div>
            <div className="safety-hero__title home-display">Registrations</div>
            <div className="safety-hero__meta">{metaLine}</div>
          </div>
          <div className="home-sheet safety-sheet">
            <section className="safety-section">
              <h2 className="safety-section__title home-section-label">Documents</h2>
              {docs.length === 0 && !loading ? (
                <div className="scoreboard-empty">
                  <strong>No registrations</strong>
                  <p>Registration documents will appear here when available.</p>
                </div>
              ) : null}
              <div className="safety-doc-list">
                {docs.map((doc: any, index: number) => (
                  <button
                    key={doc.docId}
                    type="button"
                    className="safety-doc-row"
                    style={{ ['--safety-delay' as string]: `${0.35 + index * 0.04}s` }}
                    onClick={() => {setSelectedDoc(doc); setShowModalDoc(true)}}
                  >
                    <span className="safety-doc-row__icon" aria-hidden="true">
                      <FolderDocIcon size={18} />
                    </span>
                    <span className="safety-doc-row__label">Registration: Date {doc.uploadDate}</span>
                    <ChevronRight color="oklch(0.55 0.01 260)" />
                  </button>
                ))}
              </div>
            </section>
          </div>
        </div>
      </IonContent>

      <IonModal isOpen={showModalDoc} cssClass="safety-viewer-modal" onDidDismiss={() => setShowModalDoc(false)}>
        <div className="safety-media-modal">
          <div className="safety-media-modal__header">
            <button type="button" className="safety-media-modal__back" onClick={() => setShowModalDoc(false)}>
              <ChevronLeft size={20} />
              Back
            </button>
          </div>
          <div className="safety-media-modal__body safety-media-modal__body--doc">
            <img
              className="safety-media-modal__page"
              src={'data:image/jpg;base64, ' + selectedDoc.extractedDoc}
              alt="Registration document"
            />
          </div>
        </div>
      </IonModal>
    </IonPage>
  );
};

export default Registrations;
